/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')

require('./ui-kit/confirmation.js')

require('./ui-kit/header.js')

require('./ui-kit/switchers')

require('./ui-kit/audio-pause-other.js')

require('select2/dist/js/select2.full')

require('bootstrap-datepicker/js/bootstrap-datepicker')

require('jquery-mask-plugin')

require('jquery-validation')

require('datatables.net')

import * as bootstrap from 'bootstrap'
window.Modal = bootstrap.Modal

$(document).ajaxError(function (event, request, settings) {
    if (request.status == 419) {
        let pathname = window.location.pathname.split('/')[1]
        switch (pathname) {
            case 'admin':
                location.href = '/admin/login'
                break
            default:
                location.href = '/login'
        }
    }
})
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import JsonExcel from 'vue-json-excel'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import autofocus from '@/helpers/autofocus.js'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VueSocialSharing)

Vue.directive('autofocus', autofocus)

const Swal = require('sweetalert2')

Vue.component('downloadExcel', JsonExcel)
Vue.component('vue-calendar', require('./components/calendar/index').default)
Vue.component('vue-mail-chat', require('./components/mail-chat/index').default)
Vue.component('vue-artist-bids', require('./components/bids/index-artist').default)
Vue.component('vue-artist-bids-guest', require('./components/bids/index-artist-guest').default)
Vue.component('vue-artist-opportunities', require('./components/bids/events/ArtistOpportunities.vue').default)
Vue.component('vue-guest-sing-up', require('./components/auth/index-guest-sing-up').default)
Vue.component('vue-venue-bids', require('./components/bids/index-venue').default)
Vue.component('vue-artists-info', require('./components/bids/artists-info').default)
Vue.component('vue-artist-info', require('./components/bids/artist-info').default)
Vue.component('vue-filters', require('./components/bids/filters').default)
Vue.component('vue-filters-guest', require('./components/bids/filters-guest').default)
Vue.component('vue-saved-artists', require('./components/bids/saved-artists').default)
Vue.component('vue-ignore-artists', require('./components/bids/ignored-artists').default)
Vue.component('vue-users-list', require('./components/admin/users/users-list').default)
Vue.component('vue-all-artists-info', require('./components/bids/AllArtistsInfo').default)
Vue.component('vue-search-logs', require('./components/admin/SearchLogs').default)
Vue.component('vue-bids-list', require('./components/admin/bids-list/BidsList').default)
Vue.component('vue-artists-table', require('./components/admin/dashboard/bezdev/ArtistTable.vue').default)
Vue.component('vue-venues-table', require('./components/admin/dashboard/bezdev/VenueTable.vue').default)
Vue.component('vue-users-table', require('./components/admin/dashboard/bezdev/UserTable.vue').default)
Vue.component('vue-transactions-table', require('./components/admin/dashboard/bezdev/TransactionsTable.vue').default)
Vue.component(
    'vue-cost-of-sales-and-marketing',
    require('./components/admin/dashboard/finance/CostOfSalesAndMarketing.vue').default
)
Vue.component('vue-user-value', require('./components/admin/dashboard/finance/UserValue.vue').default)
Vue.component('vue-venue-value', require('./components/admin/dashboard/finance/VenueValue.vue').default)
Vue.component('vue-artist-value', require('./components/admin/dashboard/finance/ArtistValue.vue').default)
Vue.component('vue-finance-dashboard', require('./components/admin/dashboard/finance/FinanceDashboard.vue').default)
Vue.component('vue-bez-dev-dashboard', require('./components/admin/dashboard/bezdev/BezDevDashboard.vue').default)
Vue.component(
    'vue-marketing-dashboard',
    require('./components/admin/dashboard/marketing/MarketingDashboard.vue').default
)
Vue.component('vue-get-started', require('./components/get-started/GetStarted.vue').default)
Vue.component('vue-stripe-profile', require('./components/stripe-profile/StripeProfile.vue').default)
Vue.component('vue-billing-history', require('./components/stripe-profile/BillingHistory.vue').default)
Vue.component('vue-payment-details', require('./components/payment-details/PaymentDetails.vue').default)
Vue.component('vue-side-nav', require('./components/parts/SideNav.vue').default)
Vue.component('vue-home-page', require('./components/home-page/HomePage.vue').default)
Vue.component('vue-artist-page', require('./components/home-page/ArtistPage.vue').default)
Vue.component('vue-venue-page', require('./components/home-page/VenuePage.vue').default)
Vue.component('vue-footer', require('./components/parts/Footer.vue').default)
Vue.component('vue-header', require('./components/parts/Header.vue').default)
Vue.component('vue-upfluence-profile', require('./components/upfluence-profile/UpfluenceProfile.vue').default)
Vue.component('vue-profile', require('./components/user/profile/Profile.vue').default)
Vue.component('vue-user-settings', require('./components/user/profile/ProfileSettings.vue').default)
Vue.component('vue-venue-profile', require('./components/user/profile/venue/VenueProfile.vue').default)
Vue.component('vue-artist-profile', require('./components/user/profile/artist/ArtistProfile.vue').default)
Vue.component('vue-profiles-landing', require('./components/user/profile/ProfilesLanding.vue').default)
Vue.component('vue-blog', require('./components/blog/Blog.vue').default)
Vue.component('vue-venue-subscription', require('./components/Stripe/SubscriptionVenue.vue').default)
Vue.component('vue-artist-subscription', require('./components/Stripe/SubscriptionArtist.vue').default)
Vue.component(
    'vue-subscription-admin-table',
    require('./components/admin/subscriptions/SubscriptionsAdminTable.vue').default
)
Vue.component(
    'vue-venue-profile-registration',
    require('./components/registration/venue/venue-profile-creation/VenueProfileRegistration.vue').default
)
Vue.component(
    'vue-venue-event-registration',
    require('./components/registration/venue/venue-events-creation/VenueEventRegistration.vue').default
)
Vue.component(
    'vue-up-comming-events-venue',
    require('./components/registration/venue/venue-events-creation/UpCommingEventsVenue.vue').default
)
Vue.component('vue-store-artist-profile', require('./components/user/profile/artist/StoreArtistProfile.vue').default)
Vue.component('vue-store-venue-profile', require('./components/user/profile/venue/StoreVenueProfile.vue').default)
Vue.component('vue-venue-booking-manager', require('./components/booking-manager/VenueBookingManager.vue').default)
Vue.component('vue-book-artist', require('./components/booking-manager/booking-part/EventManagePage.vue').default)
Vue.component('vue-advance-step', require('./components/booking-manager/booking-part/EventAdvancedPage.vue').default)
Vue.component('vue-wrap-up-step', require('./components/booking-manager/booking-part/EventWrapUpPage.vue').default)
Vue.component('vue-profile-contacts', require('./components/contacts/NewContacts.vue').default)
Vue.component('vue-login-popups', require('./components/user/login-popups/LoginPopups.vue').default)
Vue.component('vue-contact-us', require('./components/footer-pages/ContactUs.vue').default)
Vue.component('vue-faqs-page', require('./components/footer-pages/faqs.vue').default)
Vue.component('vue-password-reset', require('./components/password-reset/ResetPassword.vue').default)
Vue.component('vue-artist-event-list', require('./components/booking-manager/artist/ArtistEventList.vue').default)
Vue.component(
    'vue-artist-wrap-up-step',
    require('./components/booking-manager/artist/wrap-up-step/ArtistWrapUpStep.vue').default
)
Vue.component(
    'vue-artist-advance-step',
    require('./components/booking-manager/artist/advance-step/AdvanceArtistStep.vue').default
)
Vue.component(
    'vue-artist-event-page',
    require('./components/booking-manager/artist/make-offer-step/ArtistEventPage.vue').default
)
Vue.component('vue-relevant-artists-list', require('./components/booking-manager/RelevantArtistsList.vue').default)
Vue.component('vue-relevant-venues-list', require('./components/booking-manager/RelevantVenuesList.vue').default)
Vue.component('vue-exploration', require('./components/exploration/Exploration.vue').default)
Vue.component('vue-terms-police', require('./components/footer-pages/TermsPolice.vue').default)
Vue.component('vue-legal', require('./components/footer-pages/LegalPages.vue').default)

Vue.component('vue-register-page', require('./components/Login-register/RegisterPage.vue').default)
Vue.component('vue-login-page', require('./components/Login-register/LoginPage.vue').default)
Vue.component('vue-reset-password', require('./components/Login-register/password-reset/PassReset.vue').default)
Vue.component(
    'vue-reset-password-by-phone',
    require('./components/Login-register/password-reset/PasswordResetByPhone.vue').default
)
Vue.component('vue-notification', require('./components/parts/Notification.vue').default)
Vue.component('vue-about-us', require('./components/home-page/AboutPage.vue').default)
Vue.component(
    'vue-event-preview',
    require('./components/booking-manager/booking-part/event-preview/EventPreviewPage.vue').default
)
Vue.component(
    'vue-completed-history-venue',
    require('./components/booking-manager/booking-part/completed-event/CompletedHistoryView.vue').default
)
Vue.component(
    'vue-completed-history-artist',
    require('./components/booking-manager/artist/completed-event/CompletedHistoryView.vue').default
)
Vue.component(
    'vue-completed-history-venue',
    require('./components/booking-manager/booking-part/completed-event/CompletedHistoryView.vue').default
)
Vue.component('vue-kpi', require('./components/admin/KPI.vue').default)
Vue.component('vue-artist-commission', require('./components/admin/subscriptions/ArtistCommissions.vue').default)
Vue.component('vue-venue-commission', require('./components/admin/subscriptions/VenueCommissions.vue').default)
Vue.component(
    'vue-unclaimed-profiles',
    require('./components/admin/unclaimed-artists/UnclaimedArtistProfileList.vue').default
)
Vue.component('vue-affiliates-admin', require('./components/admin/affiliates/AffiliatesAdmin.vue').default)
Vue.component('vue-booker-profile', require('./components/user/profile/booker/BookerProfile.vue').default)

if ($('#app').length) {
    const app = new Vue({
        el: '#app'
    })
}
